module.exports = __webpack_public_path__ + "assets/1cf07a4e9cccfd905193c0cce7cfb916.mp3";